import { ref } from 'vue';

export const isMobileSheetOpen = ref(false);
